<template>
  <el-cascader ref="cascader" v-model="value"
               :options="options"
               :props="props"
               @change="change"
               :placeholder="placeholder"
               :style="css"
               :key="isResourceShow"
               filterable
               size="small"
               clearable>
  </el-cascader>
</template>

<script>
import { getTagList } from "@/api/system"
export default {
  name: "tagCas",
  props: {
    css: {
      type: Object,
      default: () => {
        return { width: "100%" };
      }
    },
    props: {
      type: Object,
      default: () => {
        return { expandTrigger: "hover" };
      }
    },
    placeholder: {
      type: String,
      default: "请选择标签"
    },
    deep: {
      type: Number,
      default: 0
    },
    fArray: {
      type: Array,
      default: () => {
        return [];
      }
    },
    shopId: [String,Number],
  },
  data() {
    return {
      value: "",
      options: [],
      isResourceShow: 0
    };
  },
  watch: {
    shopId: {
      deep: true,
      handler(val) {
        this.getTagList()
      }
    }
  },
  mounted() {
    this.getTagList();
  },
  methods: {
    // 获取分类
    getTagList() {
      getTagList({status:1}).then( res=>{
        if(res.code == 0){
          let data= [];
          res.data.forEach(item => {
            item.value = item.id;
            item.label = item.tagName;
            item.level = 1;
            item.children = item.tagTipList;
            data.push(item);
            item.tagTipList.forEach(item2 => {
              item2.value = item2.id;
              item2.label = item2.tagName;
              item2.level = 2;
            });
          });
          ++this.isResourceShow;
          this.options = data;
        }
      })
    },
    change(value) {
      // let name=this.$refs['cascader'].getCheckedNodes().length==0?'':this.$refs['cascader'].getCheckedNodes()[0].label
      // this.$emit("getCategory",value,name);
      // console.log(this.$refs['cascader'].getCheckedNodes()[0]);
      // console.log(value);
      //取消已选中的
      if(Array.isArray(value)&&value.length==0){       // 多选 取消勾选
        this.options=this.setNoDisabled(this.options)
        this.$emit("getCategory",value);
      }else{
        let a=this.$refs['cascader'].getCheckedNodes();
        if(this.props.multiple){    //多选
          let level=a.length==0?'':a[0].level;
          this.options=this.setLevelDisabled(this.options,level)
          this.$emit("getCategory",value,a[0].level);
        }else{                    //单选
          let name=a.length==0?'':a[0].label
          this.$emit("getCategory",value,name);
        }

      }

    },
    reset() {
      this.value = "";
      ++this.isResourceShow;
      this.options=this.setNoDisabled(this.options)
      this.$refs.cascader.handleClear();
    },
    setLevelDisabled(data,level){
      let tree = [];
      data.forEach(item => {
        if (item.level != level) {
          item.disabled = true
        }
        item.children&&this.setLevelDisabled(item.children,level)
        tree.push(item)
      })
      return tree;
    },
    setNoDisabled(data){
      let tree = [];
      data.forEach(item => {
        // console.log(item.children);
        item.disabled = false
        item.children&&this.setNoDisabled(item.children)
        tree.push(item)
      })
      return tree;


    }

  }
};
</script>




// WEBPACK FOOTER //
// src/components/TagSelect/index.vue